import { ReactComponent as arrowLeft } from './assets/arrowLeft.svg';
import { ReactComponent as arrowRight } from './assets/arrowRight.svg';
import { ReactComponent as calendar } from './assets/calendar.svg';
import { ReactComponent as checkedCalendar } from './assets/checkedCalendar.svg';
import { ReactComponent as chevronDown } from './assets/chevronDown.svg';
import { ReactComponent as chevronLeft } from './assets/chevronLeft.svg';
import { ReactComponent as chevronRight } from './assets/chevronRight.svg';
import { ReactComponent as chevronUp } from './assets/chevronUp.svg';
import { ReactComponent as clock } from './assets/clock.svg';
import { ReactComponent as close } from './assets/close.svg';
import { ReactComponent as dietTypeOmnivore } from './assets/dietTypeOmnivore.svg';
import { ReactComponent as dietTypePescatarian } from './assets/dietTypePescatarian.svg';
import { ReactComponent as dietTypeVegetarian } from './assets/dietTypeVegetarian.svg';
import { ReactComponent as heartFilled } from './assets/heartFilled.svg';
import { ReactComponent as heartOutline } from './assets/heartOutline.svg';
import { ReactComponent as homemade } from './assets/homemade.svg';
import { ReactComponent as info } from './assets/info.svg';
import { ReactComponent as kidFriendly } from './assets/kidFriendly.svg';
import { ReactComponent as leavesCircle } from './assets/leavesCircle.svg';
import { ReactComponent as lockClosed } from './assets/lockClosed.svg';
import { ReactComponent as main } from './assets/main.svg';
import { ReactComponent as message } from './assets/message.svg';
import { ReactComponent as minus } from './assets/minus.svg';
import { ReactComponent as mixingBowl } from './assets/mixingBowl.svg';
import { ReactComponent as movingDish } from './assets/movingDish.svg';
import { ReactComponent as openPot } from './assets/openPot.svg';
import { ReactComponent as plus } from './assets/plus.svg';
import { ReactComponent as plusHandWritten } from './assets/plusHandWritten.svg';
import { ReactComponent as portraitAdult1 } from './assets/portraitAdult1.svg';
import { ReactComponent as portraitAdult2 } from './assets/portraitAdult2.svg';
import { ReactComponent as portraitAdult3 } from './assets/portraitAdult3.svg';
import { ReactComponent as portraitChild1 } from './assets/portraitChild1.svg';
import { ReactComponent as portraitChild2 } from './assets/portraitChild2.svg';
import { ReactComponent as portraitChild3 } from './assets/portraitChild3.svg';
import { ReactComponent as portraitSmallChild } from './assets/portraitSmallChild.svg';
import { ReactComponent as promo } from './assets/promo.svg';
import { ReactComponent as proteinBeef } from './assets/proteinBeef.svg';
import { ReactComponent as proteinChicken } from './assets/proteinChicken.svg';
import { ReactComponent as proteinEgg } from './assets/proteinEgg.svg';
import { ReactComponent as proteinFish } from './assets/proteinFish.svg';
import { ReactComponent as proteinLamb } from './assets/proteinLamb.svg';
import { ReactComponent as proteinPlant } from './assets/proteinPlant.svg';
import { ReactComponent as proteinPork } from './assets/proteinPork.svg';
import { ReactComponent as proteinShellfish } from './assets/proteinShellfish.svg';
import { ReactComponent as proteinTofu } from './assets/proteinTofu.svg';
import { ReactComponent as questionMark } from './assets/questionMark.svg';
import { ReactComponent as restrictionDairyFree } from './assets/restrictionDairyFree.svg';
import { ReactComponent as restrictionGlutenFree } from './assets/restrictionGlutenFree.svg';
import { ReactComponent as restrictionOther } from './assets/restrictionOther.svg';
import { ReactComponent as reusablePackaging } from './assets/reusablePackaging.svg';
import { ReactComponent as african } from './assets/revamped-marketplace-cuisines/african.svg';
import { ReactComponent as africanActive } from './assets/revamped-marketplace-cuisines/africanActive.svg';
import { ReactComponent as allFood } from './assets/revamped-marketplace-cuisines/allFood.svg';
import { ReactComponent as allFoodActive } from './assets/revamped-marketplace-cuisines/allFoodActive.svg';
import { ReactComponent as american } from './assets/revamped-marketplace-cuisines/american.svg';
import { ReactComponent as americanActive } from './assets/revamped-marketplace-cuisines/americanActive.svg';
import { ReactComponent as bakedGoods } from './assets/revamped-marketplace-cuisines/bakedGoods.svg';
import { ReactComponent as bakedGoodsActive } from './assets/revamped-marketplace-cuisines/bakedGoodsActive.svg';
import { ReactComponent as caribbean } from './assets/revamped-marketplace-cuisines/caribbean.svg';
import { ReactComponent as caribbeanActive } from './assets/revamped-marketplace-cuisines/caribbeanActive.svg';
import { ReactComponent as chinese } from './assets/revamped-marketplace-cuisines/chinese.svg';
import { ReactComponent as chineseActive } from './assets/revamped-marketplace-cuisines/chineseActive.svg';
import { ReactComponent as eastIndian } from './assets/revamped-marketplace-cuisines/eastIndian.svg';
import { ReactComponent as eastIndianActive } from './assets/revamped-marketplace-cuisines/eastIndianActive.svg';
import { ReactComponent as fusion } from './assets/revamped-marketplace-cuisines/fusion.svg';
import { ReactComponent as fusionActive } from './assets/revamped-marketplace-cuisines/fusionActive.svg';
import { ReactComponent as genericCuisine } from './assets/revamped-marketplace-cuisines/genericCuisine.svg';
import { ReactComponent as genericCuisineActive } from './assets/revamped-marketplace-cuisines/genericCuisineActive.svg';
import { ReactComponent as indian } from './assets/revamped-marketplace-cuisines/indian.svg';
import { ReactComponent as indianActive } from './assets/revamped-marketplace-cuisines/indianActive.svg';
import { ReactComponent as indoChinese } from './assets/revamped-marketplace-cuisines/indoChinese.svg';
import { ReactComponent as indoChineseActive } from './assets/revamped-marketplace-cuisines/indoChineseActive.svg';
import { ReactComponent as italian } from './assets/revamped-marketplace-cuisines/italian.svg';
import { ReactComponent as italianActive } from './assets/revamped-marketplace-cuisines/italianActive.svg';
import { ReactComponent as japanese } from './assets/revamped-marketplace-cuisines/japanese.svg';
import { ReactComponent as japaneseActive } from './assets/revamped-marketplace-cuisines/japaneseActive.svg';
import { ReactComponent as korean } from './assets/revamped-marketplace-cuisines/korean.svg';
import { ReactComponent as koreanActive } from './assets/revamped-marketplace-cuisines/koreanActive.svg';
import { ReactComponent as latinAmerica } from './assets/revamped-marketplace-cuisines/latinAmerica.svg';
import { ReactComponent as latinAmericaActive } from './assets/revamped-marketplace-cuisines/latinAmericaActive.svg';
import { ReactComponent as mediterranean } from './assets/revamped-marketplace-cuisines/mediterranean.svg';
import { ReactComponent as mediterraneanActive } from './assets/revamped-marketplace-cuisines/mediterraneanActive.svg';
import { ReactComponent as mexico } from './assets/revamped-marketplace-cuisines/mexico.svg';
import { ReactComponent as mexicoActive } from './assets/revamped-marketplace-cuisines/mexicoActive.svg';
import { ReactComponent as middleEastern } from './assets/revamped-marketplace-cuisines/middleEastern.svg';
import { ReactComponent as middleEasternActive } from './assets/revamped-marketplace-cuisines/middleEasternActive.svg';
import { ReactComponent as northIndian } from './assets/revamped-marketplace-cuisines/northIndian.svg';
import { ReactComponent as northIndianActive } from './assets/revamped-marketplace-cuisines/northIndianActive.svg';
import { ReactComponent as pakistani } from './assets/revamped-marketplace-cuisines/pakistani.svg';
import { ReactComponent as pakistaniActive } from './assets/revamped-marketplace-cuisines/pakistaniActive.svg';
import { ReactComponent as southEastAsia } from './assets/revamped-marketplace-cuisines/southEastAsia.svg';
import { ReactComponent as southEastAsiaActive } from './assets/revamped-marketplace-cuisines/southEastAsiaActive.svg';
import { ReactComponent as southern } from './assets/revamped-marketplace-cuisines/southern.svg';
import { ReactComponent as southernActive } from './assets/revamped-marketplace-cuisines/southernActive.svg';
import { ReactComponent as southIndian } from './assets/revamped-marketplace-cuisines/southIndian.svg';
import { ReactComponent as southIndianActive } from './assets/revamped-marketplace-cuisines/southIndianActive.svg';
import { ReactComponent as westIndian } from './assets/revamped-marketplace-cuisines/westIndian.svg';
import { ReactComponent as westIndianActive } from './assets/revamped-marketplace-cuisines/westIndianActive.svg';
import { ReactComponent as sides } from './assets/sides.svg';
import { ReactComponent as starEmpty } from './assets/starEmpty.svg';
import { ReactComponent as starFilled } from './assets/starFilled.svg';
import { ReactComponent as starHalf } from './assets/starHalf.svg';
import { ReactComponent as tasteVerified } from './assets/tasteVerified.svg';
import { ReactComponent as thumbsDown } from './assets/thumbsDown.svg';
import { ReactComponent as thumbsUp } from './assets/thumbsUp.svg';
import { ReactComponent as twinklyStars } from './assets/twinklyStars.svg';
import { ReactComponent as verifiedCheck } from './assets/verifiedCheck.svg';
/**
 * When adding new icons, be sure that all colors in the SVG that should inherit the color are updated. This looks
 * like changing the property of all `<path>` and `<rect>` elements to use `currentColor` for any color you want
 * to be inherited (i.e. `fill="currentColor"` and `stroke="currentColor"`). Also be sure that the `<svg>` element
 * has `fill="none"` to make the background transparent.
 */

const revampedCuisineIcons = {
  african,
  africanActive,
  allFood,
  allFoodActive,
  american,
  americanActive,
  bakedGoods,
  bakedGoodsActive,
  caribbean,
  caribbeanActive,
  chinese,
  chineseActive,
  eastIndian,
  eastIndianActive,
  fusion,
  fusionActive,
  genericCuisine,
  genericCuisineActive,
  indian,
  indianActive,
  indoChinese,
  indoChineseActive,
  italian,
  italianActive,
  japanese,
  japaneseActive,
  korean,
  koreanActive,
  latinAmerica,
  latinAmericaActive,
  mediterranean,
  mediterraneanActive,
  mexico,
  mexicoActive,
  middleEastern,
  middleEasternActive,
  northIndian,
  northIndianActive,
  pakistani,
  pakistaniActive,
  southEastAsia,
  southEastAsiaActive,
  southIndian,
  southIndianActive,
  southern,
  southernActive,
  westIndian,
  westIndianActive,
};

export const icons = {
  ...revampedCuisineIcons,
  arrowLeft,
  arrowRight,
  calendar,
  checkedCalendar,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  clock,
  close,
  dietTypeOmnivore,
  dietTypePescatarian,
  dietTypeVegetarian,
  heartOutline,
  heartFilled,
  homemade,
  info,
  kidFriendly,
  leavesCircle,
  lockClosed,
  main,
  message,
  minus,
  mixingBowl,
  movingDish,
  openPot,
  plus,
  portraitAdult1,
  portraitAdult2,
  portraitAdult3,
  portraitChild1,
  portraitChild2,
  portraitChild3,
  portraitSmallChild,
  promo,
  proteinBeef,
  proteinChicken,
  proteinEgg,
  proteinFish,
  proteinLamb,
  proteinPlant,
  proteinPork,
  proteinShellfish,
  proteinTofu,
  questionMark,
  restrictionDairyFree,
  restrictionGlutenFree,
  restrictionOther,
  reusablePackaging,
  sides,
  starHalf,
  starFilled,
  starEmpty,
  tasteVerified,
  thumbsUp,
  thumbsDown,
  twinklyStars,
  verifiedCheck,
  plusHandWritten,
};
